import { useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export function VisibilityToggle({ endpoint, hidden, onChange }) {
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = async (visible) => {
    setBusy(true);
    try { await api.put(endpoint, { visible }); toast.success(visible ? "Your profile is visible again" : "Your profile is now hidden"); onChange?.(!visible); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); setAsk(false); }
  };
  return (
    <section className={`surface p-5 mb-6 flex items-start gap-4 border-l-4 ${hidden ? "border-[#FF9700]" : "border-[#086B2D]"}`} data-testid="visibility-section">
      {hidden ? <EyeOff className="h-5 w-5 text-[#9A5B00] mt-0.5" /> : <Eye className="h-5 w-5 text-[#086B2D] mt-0.5" />}
      <div className="flex-1 min-w-0">
        <p className="font-semibold" data-testid="visibility-status">{hidden ? "Profile hidden" : "Profile visible"}</p>
        <p className="text-sm muted mt-0.5">{hidden ? "Nobody on the platform can find or book you. Your existing bookings and orders continue as usual." : "Patients can find you and place new bookings or orders."}</p>
      </div>
      <Switch checked={!hidden} disabled={busy} onCheckedChange={(v) => (v ? save(true) : setAsk(true))} data-testid="visibility-toggle" />
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent data-testid="visibility-confirm-dialog">
          <AlertDialogHeader><AlertDialogTitle>Turn off profile visibility?</AlertDialogTitle>
            <AlertDialogDescription>Are you sure? Your profile will no longer be visible to anyone on the platform, and no new bookings or orders can be placed with you. Existing ones continue. You can switch visibility back on at any time.</AlertDialogDescription></AlertDialogHeader>
          <AlertDialogFooter><AlertDialogCancel data-testid="visibility-cancel-btn">Keep visible</AlertDialogCancel>
            <AlertDialogAction onClick={() => save(false)} className="bg-[#B42318] hover:bg-[#912018]" data-testid="visibility-confirm-btn">Yes, hide my profile</AlertDialogAction></AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}

export const HiddenBadge = ({ hidden, testId }) => hidden ? <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-[#FF9700]/15 px-2 py-0.5 text-[11px] font-semibold text-[#9A5B00]" data-testid={testId || "hidden-badge"}><EyeOff className="h-3 w-3" />Hidden</span> : null;
